import {inject} from '@angular/core';
import {CanActivateFn, Route} from '@angular/router';
import {SeFeFrameRouterService} from 'se-fe-frame-router';
import {ErrorComponent} from './error/error.component';
import {NotFoundComponent} from './error/not-found/not-found.component';
import {BundleListComponent} from './features/bundle-list/bundle-list.component';
import {BundleDetailComponent} from './features/bundle/components/bundle-detail/bundle-detail.component';
import {CreateBundleComponent} from './features/bundle/components/create-bundle/create-bundle.component';
import {ClareOnboardingComponent} from './features/clare/clare-onboarding/clare-onboarding.component';
import {CatalogDetailComponent} from './features/catalog-detail/catalog-detail.component';
import {CatalogListComponent} from './features/catalog-list/catalog-list.component';
import {CommerceShellComponent} from './features/commerce-shell/commerce-shell.component';
import {ProductListComponent} from './features/product-list/product-list.component';
import {CreateProductComponent} from './features/product/components/create-product/create-product.component';
import {ProductDetailComponent} from './features/product/components/product-detail/product-detail.component';
import {clareOnboardingAccountGuard} from './resolvers/clare-onboarding.guard';
import {organizationNameResolver} from './resolvers/organization-name.resolver';

const frameRouterGuard: CanActivateFn = (route, state) => {
  const frameRouterService = inject(SeFeFrameRouterService);
  return frameRouterService.canActivate(route, state);
};

export const appRoutes: Route[] = [
  {
    path: 'org/:currentOrgId/commerce',
    canActivate: [frameRouterGuard, clareOnboardingAccountGuard],
    resolve: {
      orgName: organizationNameResolver,
    },
    children: [
      {
        path: '',
        component: CommerceShellComponent,
        children: [
          {
            path: 'products',
            pathMatch: 'full',
            component: ProductListComponent,
            data: {frameRouterTitle: 'Products'},
          },
          {
            path: 'bundles',
            pathMatch: 'full',
            component: BundleListComponent,
            data: {frameRouterTitle: 'Bundles'},
          },
          {
            path: 'catalogs',
            pathMatch: 'full',
            component: CatalogListComponent,
            data: {frameRouterTitle: 'Catalogs'},
          },
        ],
      },
      {
        path: 'products',
        data: {
          frameRouterTitle: 'Products',
        },
        children: [
          {
            path: 'new',
            component: CreateProductComponent,
            data: {frameRouterTitle: 'Create product'},
          },
          {
            path: ':productId',
            component: ProductDetailComponent,
            data: {frameRouterTitle: 'Product detail'},
          },
        ],
      },
      {
        path: 'bundles',
        data: {
          frameRouterTitle: 'Bundles',
        },
        children: [
          {
            path: 'new',
            component: CreateBundleComponent,
            data: {frameRouterTitle: 'Create bundle'},
          },
          {
            path: ':productId',
            component: BundleDetailComponent,
            data: {frameRouterTitle: 'Bundle detail'},
          },
        ],
      },
      {
        path: 'catalogs',
        data: {frameRouterTitle: 'Catalogs'},
        children: [
          {
            path: ':catalogId',
            component: CatalogDetailComponent,
            data: {frameRouterTitle: 'Catalog Detail'},
          },
        ],
      },
      {
        path: 'not-found',
        component: NotFoundComponent,
        data: {
          frameRouterTitle: 'Not Found',
        },
      },
    ],
  },
  {
    path: 'org/:currentOrgId/clare-onboarding',
    component: ClareOnboardingComponent,
  },
  {
    path: 'org/:currentOrgId',
    redirectTo: 'org/:currentOrgId/commerce/products',
    pathMatch: 'full',
    data: {
      frameRouterTitle: 'Products',
    },
  },
  {
    path: '**',
    component: ErrorComponent,
    data: {
      frameRouterTitle: 'Error',
    },
  },
];
